import { render, staticRenderFns } from "./roleDetail.vue?vue&type=template&id=b12dd64e&scoped=true&"
import script from "./roleDetail.vue?vue&type=script&lang=js&"
export * from "./roleDetail.vue?vue&type=script&lang=js&"
import style0 from "./roleDetail.vue?vue&type=style&index=0&id=b12dd64e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b12dd64e",
  null
  
)

export default component.exports